import script from "./fileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./fileCard.vue?vue&type=script&setup=true&lang=js"

import "./fileCard.vue?vue&type=style&index=0&id=4a600c7e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a600c7e"]])

export default __exports__